/**
 * Hook returning the current JWT auth context value.
 */

import { useContext } from 'react';
import { JWTAuthContext } from './jwtAuthContextInstance';

export const useJWTAuth = () => {
  const context = useContext(JWTAuthContext);

  if (context === undefined) {
    throw new Error('useJWTAuth must be used within a JWTAuthProvider');
  }

  return context;
};
